import * as fromDatatype from '../datatype-library/index';

export interface bl_aat_claim_claimant_entity_claim_doc_line_favourite_link_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  claim_doc_line_guid: fromDatatype.GuidDataFieldInterface;
  claimant_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  claimant_claim_item_hdr_guid: fromDatatype.GuidDataFieldInterface;
  claim_item_category_01_guid: fromDatatype.GuidDataFieldInterface;
  expense_cost_center_comp_hdr_guid: fromDatatype.GuidDataFieldInterface;
  expense_cost_center_branch_guid: fromDatatype.GuidDataFieldInterface;
  title: fromDatatype.VarcharDatatypeInterface;
  claim_type: fromDatatype.VarcharDatatypeInterface;
  rank: fromDatatype.IntegerDatatypeInterface;
  claim_doc_line_info_json: fromDatatype.JsonDatatypeInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_by_name: fromDatatype.VarcharDatatypeInterface;
  updated_by_name: fromDatatype.VarcharDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
}

export class bl_aat_claim_claimant_entity_claim_doc_line_favourite_link_RowClass implements bl_aat_claim_claimant_entity_claim_doc_line_favourite_link_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    claim_doc_line_guid: fromDatatype.GuidDataFieldInterface;
    claimant_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
    claimant_claim_item_hdr_guid: fromDatatype.GuidDataFieldInterface;
    claim_item_category_01_guid: fromDatatype.GuidDataFieldInterface;
    expense_cost_center_comp_hdr_guid: fromDatatype.GuidDataFieldInterface;
    expense_cost_center_branch_guid: fromDatatype.GuidDataFieldInterface;
    title: fromDatatype.VarcharDatatypeInterface;
    claim_type: fromDatatype.VarcharDatatypeInterface;
    rank: fromDatatype.IntegerDatatypeInterface;
    claim_doc_line_info_json: fromDatatype.JsonDatatypeInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    created_by_name: fromDatatype.VarcharDatatypeInterface;
    updated_by_name: fromDatatype.VarcharDatatypeInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    status: fromDatatype.VarcharDatatypeInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharDatatypeInterface;
}
